import React, { Dispatch, SetStateAction } from "react";

import { Checkbox } from "antd";
import i18next from "i18next";
import styled from "styled-components";

import { BSCoreWebRequestsResponsesDistributorsDistributorDepotResponse } from "api/reactQuery/querySchemas";

type Props = {
  depot: BSCoreWebRequestsResponsesDistributorsDistributorDepotResponse;
  selectedDepots?: BSCoreWebRequestsResponsesDistributorsDistributorDepotResponse[];
  setSelectedDepots?: Dispatch<
    SetStateAction<
      BSCoreWebRequestsResponsesDistributorsDistributorDepotResponse[]
    >
  >;
};

const WarehouseCard: React.FC<Props> = ({
  depot,
  selectedDepots,
  setSelectedDepots,
}) => {
  return (
    <Wrapper key={depot.officialDepotName}>
      {selectedDepots ? (
        <Checkbox
          value={depot}
          checked={selectedDepots.includes(depot)}
          onChange={(e) => {
            if (e.target.checked) {
              return setSelectedDepots((prev) => [...prev, e.target.value]);
            }

            return setSelectedDepots((prev) =>
              prev.filter((depot) => depot !== e.target.value)
            );
          }}
          disabled={
            selectedDepots.length > 1
              ? selectedDepots.includes(depot)
                ? false
                : true
              : false
          }
        >
          <WarehouseName>{depot.officialDepotName}</WarehouseName>
        </Checkbox>
      ) : (
        <WarehouseName>{depot.officialDepotName}</WarehouseName>
      )}

      <Info>
        <InfoLabel>{i18next.t("total_balance")}</InfoLabel>
        <InfoValue>{depot.totalDistributorBalance} €</InfoValue>
      </Info>

      <Info>
        <InfoLabel>{i18next.t("depot_address")}</InfoLabel>
        <InfoValue>{depot.deliveryAddress}</InfoValue>
      </Info>

      <Info>
        <InfoLabel>{i18next.t("depot_contact_name")}</InfoLabel>
        <InfoValue>{depot.contactPersonName}</InfoValue>
      </Info>

      <Info>
        <InfoLabel>{i18next.t("contact_person_phone")}</InfoLabel>
        <InfoValue>{depot.contactPersonPhone}</InfoValue>
      </Info>
    </Wrapper>
  );
};

export default WarehouseCard;

const Wrapper = styled.div`
  width: 100%;
  background: #fcfbfb;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
`;

const InfoLabel = styled.p`
  color: #5c5c5c;
  font-size: 12px;
  font-weight: 400;
`;

const InfoValue = styled.p`
  color: #181818;
  font-size: 16px;
  font-weight: 400;
`;

const Info = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const WarehouseName = styled.h1`
  font-weight: 800;
  font-size: 20px;
  color: #181818;
`;
